import React from 'react';
import styled from 'styled-components';
const StyledButton = styled.a.withConfig({
  displayName: "TransparentButton__StyledButton",
  componentId: "sc-but94h-0"
})(["display:inline-block;width:200px;padding:10px 8px;text-align:center;font-family:'Roboto',arial,sans-serif;font-size:1rem;color:", ";border-width:2px;border-style:solid;border-color:", ";border-radius:2px;background-color:", ";cursor:pointer;transition:all 300ms ease;&:hover{color:", ";background-color:", ";}&:focus{color:", ";}"], props => props.$darkFont ? '#000' : '#fff', props => props.$darkFont ? '#333333' : '#CCCCCC', props => props.$darkFont ? 'rgba(0, 0, 0, 0.01)' : 'rgba(255, 255, 255, 0.01)', props => props.$darkFont ? 'black' : 'white', props => props.$darkFont ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.2)', props => props.$darkFont ? 'black' : 'white');
export const TransparentButton = _ref => {
  let {
    text,
    darkFont,
    buttonUrl,
    className,
    title,
    LinkComponent
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledButton, {
    as: buttonUrl ? LinkComponent || 'a' : 'div',
    href: buttonUrl,
    $darkFont: darkFont,
    className: className,
    title: title
  }, text);
};
export default TransparentButton;